import React from 'react';
import { staticAsset } from '../../../utils/appPaths.js';

const SvgIcon = (props) => {
  const { iconId, ...res } = props;
  return (
    <svg {...res}>
      <use href={`${staticAsset('/svg/sprite.svg')}#${iconId}`}></use>
    </svg>
  );
};

export default SvgIcon;
